import { render } from "./AxeAnimationPage.vue?vue&type=template&id=d75e977e"
import script from "./AxeAnimationPage.vue?vue&type=script&lang=js"
export * from "./AxeAnimationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__